import React from 'react'
import { Navigate } from 'react-router-dom'

import routePath from 'router/routePath'
import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'

type ResidentChangesGateProps = {
  children: React.ReactElement
}

export const ResidentChangesGate: React.FC<ResidentChangesGateProps> = ({
  children,
}) => {
  const { contractModification } = useModuleConfig()

  return contractModification ? (
    children
  ) : (
    <Navigate to={routePath.notFound404} replace />
  )
}
